import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    userData: state.userData, // 存入localStorage的值
  }),
});

export default new Vuex.Store({
  state: {
    userData: {}
  },
  mutations: {
    // 客户基础数据
    setUserData(state, data) {
      state.userData = data;
    },
   
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});